"use client";

import ScreenLayout from '@/components/layout/screen-layout';
import { useEffect, useState } from 'react';

export interface StatItem {
  value: string;
  suffix: string;
  labelLines: string[];
}

interface BuiltForTheBestSectionProps {
  heading: string;
  stats: StatItem[];
  className?: string;
}

export default function ServicesAnimateStatsSection({
  heading,
  stats,
  className = "",
}: BuiltForTheBestSectionProps) {
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    setHasAnimated(true);
  }, []);

  return (
    <ScreenLayout outerClassName="border-y bg-[#F9FAFD]">
      <div className={`flex flex-col justify-center items-center py-6 sm:py-8 lg:py-10 ${className}`}>
        <div>
          <h2 className="text-base font-semibold text-custom-blue opacity-50 uppercase text-center">
            {heading}
          </h2>
        </div>

        <div className="flex flex-col md:flex-row w-full justify-center md:justify-around items-center gap-y-6 pt-2 px-4 md:px-0">
          {stats.map((item, index) => (
            <div key={index} className="flex items-center justify-center">
              <div className="inline-flex items-baseline text-2xl md:text-3xl lg:text-[44px] xl:text-[53.16px] text-custom-blue font-semibold">
                <span>{item.value}</span>
                <span className="ml-1">{item.suffix}</span>
              </div>

              <div className="text-sm md:text-[12px] lg:text-base font-semibold opacity-50 uppercase ml-4 leading-tight">
                <p>{item.labelLines}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </ScreenLayout>
  )
}

